import { render, staticRenderFns } from "./RefAlert.vue?vue&type=template&id=3d37c2d2&"
import script from "./RefAlert.vue?vue&type=script&lang=js&"
export * from "./RefAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports